    // VENDORS JS

    // Superfish - dropdown and megamenu with touch
    // https://superfish.joelbirch.design/download/

    @import './src/assets/vendors/superfish/superfish.js'

	// Swiper - mobile touch slider
	// https://swiperjs.com/get-started

	@import './src/assets/vendors/swiper/swiper-bundle.min.js'


	// Data Tables - advanced interaction controls to your HTML tables
	// https://datatables.net/

	@import './src/assets/vendors/datatables/jquery.dataTables.min.js'

    // APP JS

	(function($) {
	
		'use strict';

		// Desktop menu and language switchers

		$(document).ready(function() {

			if(typeof $.fn.superfish !== 'undefined'){
				
				$('#desktop-menu').superfish({
					delay: 500,
					animation: {opacity:'show',height:'show'},
					speed: 200,
					cssArrows: false
				});

				$('#desktop-languages-menu').superfish({
					delay: 0,
					animation: {opacity:'show',height:'show'},
					speed: 100,
					cssArrows: false
				});

				$('#mobile-languages-menu').superfish({
					delay: 0,
					animation: {opacity:'show',height:'show'},
					speed: 100,
					cssArrows: false
				});

				$('#g-trans-ro-1-desktop a').on( "click", function(event) {
					event.preventDefault();
					anofm_class_swap('ro');
				});
				
				$('#g-trans-en-1-desktop a').on( "click", function(event) {
					event.preventDefault();
					anofm_class_swap('en');
				});

				$('#g-trans-de-1-desktop a').on( "click", function(event) {
					event.preventDefault();
					anofm_class_swap('de');
				});

				$('#g-trans-fr-1-desktop a').on( "click", function(event) {
					event.preventDefault();
					anofm_class_swap('fr');
				});

				$('#g-trans-ro-1-mobile a').on( "click", function(event) {
					event.preventDefault();
					anofm_class_swap('ro');
				});

				$('#g-trans-en-1-mobile a').on( "click", function(event) {
					event.preventDefault();
					anofm_class_swap('en');
				});

				$('#g-trans-de-1-mobile a').on( "click", function(event) {
					event.preventDefault();
					anofm_class_swap('de');
				});

				$('#g-trans-fr-1-mobile a').on( "click", function(event) {
					event.preventDefault();
					anofm_class_swap('fr');
				});
				
				function anofm_class_swap(type){
					document.getElementById("anofm-lang-switcher0-desktop").className = 'dropdown g-trans-' + type;
					document.getElementById("anofm-lang-switcher1-desktop").className = 'g-trans-' + type;
					document.getElementById("anofm-lang-switcher0-mobile").className = 'dropdown g-trans-' + type;
					document.getElementById("anofm-lang-switcher1-mobile").className = 'g-trans-' + type;
				}
				
			}

		});
			
		// Mobile Menu

		var MOBILEBREAKPOINT = 1200;
	
		function handleMobileMenu() {

			if ($(window).width() >= MOBILEBREAKPOINT) {
				$('body').removeClass('mobile-menu-active');
			} 

		}

		function showHideMobileMenu() {
			
			$("#mobile-menu-trigger").on("click", function(event) {
				event.preventDefault();
				$('body').addClass('mobile-menu-active');
			});
			
			$("#mobile-menu-close, #site-overlay").on("click", function(event) {
				event.preventDefault();
				$('body').toggleClass('mobile-menu-active');
				$("#mobile-menu-trigger").focus();
			});
			
			$('#mobile-menu li.menu-item-has-children > a').each(function() {
				var $t = $(this);
				$t.append('<span class="mobile-menu-has-submenu closed"><i class="feather-chevron-down"></i><div class="screen-reader-text">toggle submenu</div></span>');

			});

			$('.mobile-menu-has-submenu').on('click', function(event) {
				var $t = $(this);
				if ($t.hasClass('closed')) {
					$t.removeClass('closed').addClass('opened').parent().siblings('ul').fadeIn();
					$t.find('i').removeClass('feather-chevron-down').addClass('feather-chevron-up');
				} else {
					$t.removeClass('opened').addClass('closed').parent().siblings('ul').fadeOut();
					$t.find('i').removeClass('feather-chevron-up').addClass('feather-chevron-down');
				}
				event.preventDefault();
			});
			
		}

		$(document).ready(function() {
			
			handleMobileMenu();
			showHideMobileMenu(); 
			
		});

		$(window).resize(function() {
				
			handleMobileMenu();

		});

		// Search

		$(document).ready(function() {
		
			var searchContainer = $( '#search' );
			var searchField = $( '#search input[type="search"]' );
		
			$('#search-trigger').on( 'click', function(event) {
				
				event.preventDefault();
				
				searchContainer.toggleClass( 'active' ).slideToggle(300);
				
				if ( searchContainer.hasClass( 'active' ) ) {
					searchField.focus();
				} else {
					searchField.blur();
				}	
				
			});	
			
			$( '#search-close' ).on( 'click', function( event ) {
				
				event.preventDefault();
				searchContainer.toggleClass( 'active' ).slideToggle(300);
				$('#search-trigger').focus();
				
			} );

		});
		
		// Maps

		$(document).ready(function() {
	
			$('[data-link]').on('click', function() {
				// Get the value of the data-link attribute for the clicked element
				var linkSuffix = $(this).data('link');
			
				// Get the current domain of the page
				var currentDomain = window.location.origin;
			
				// Combine the current domain with the data-link attribute value
				var completeLink = currentDomain + linkSuffix;
			
				// Redirect the browser to the complete link
				window.location.href = completeLink;
			});


		});

		// counter

		function isElementInViewport(el) {
			var rect = el.getBoundingClientRect();
		
			return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				rect.right <= (window.innerWidth || document.documentElement.clientWidth)
			);
		}
		
		// Check all elements with the class .counter
		function checkCountersInViewport() {
			var counters = document.querySelectorAll('.counter');
		
			counters.forEach(function(counter) {
				if (isElementInViewport(counter)) {
					
					$('.counter-standard').each(function() {
			
						var $t = $(this),
							n = $t.attr("data-value"),
							r = parseInt($t.attr("data-speed"), 10);
							
						if (!$t.hasClass("already-animated")) {
							$t.addClass("already-animated");
							$({
								countNum: $t.text()
							}).animate({
								countNum: n
							}, {
								duration: r,
								easing: "linear",
								step: function() {
									$t.text(Math.floor(this.countNum));
								},
								complete: function() {
									$t.text(this.countNum);
								}
							});
						}
						
					});

				} 
			});
		}
		
		// Event listener for scroll event
		window.addEventListener('scroll', checkCountersInViewport);
		
		// Initial check on page load
		checkCountersInViewport();

		// Switch Subsite
		
		$(document).ready(function() {
			
			$('#switch-subsite').change(function() {
			  
				var selectedValue = $(this).val();

				console.log(selectedValue);	

				// Check if a valid link is selected
				if (selectedValue && selectedValue !== "") {
					// Prevent default behavior (don't navigate to a new page)
					event.preventDefault();

					// Redirect to the selected link
					window.location.href = selectedValue;
				}

			});

		});

		// Data tables

		jQuery('.enhanced-table').DataTable({
			autoWidth: false,
			"order": [], // stop default sorting
			'pageLength': 25,
			"dom":  "<'d-sm-flex justify-content-between align-items-center'<f><B>>" +
					"<'d-xl-flex justify-content-between align-items-center'<i><p>>" +
					"<tr>" +
					"<'d-xl-flex flex-xl-row-reverse justify-content-between align-items-center'<p><l>>",
			buttons: [
				
			],
			initComplete: function() {

				var buttons = $('.dt-buttons button');
				buttons.removeClass('dt-button');

				this.api()
					.columns('.enhanced-table-column-filtrable')
					.every(function() {
						var column = this;
						var select = $('<select class="form-select"><option value=""></option></select>')
							.appendTo($(column.footer()).empty())
							.on('change', function() {
								var val = $.fn.dataTable.util.escapeRegex($(this).val());

								column.search(val ? '^' + val + '$' : '', true, false).draw();
							});

						column
							.data()
							.unique()
							.sort()
							.each(function(d, j) {
								var val = $('<div/>').html(d).text();
								select.append('<option value="' + val + '">' + val + '</option>'); // originally 'val' was 'd'
							});
					});
	
			},
			"columnDefs": [
				{
					"targets": "enhanced-table-column-not-sortable",
					"orderable": false,
				}, 
				{
					"targets": "enhanced-table-column-hidden-small-devices",
					"className": "d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell",
				}, 
				{
					"targets": "enhanced-table-column-wrap-text",
					"className": "text-wrap",
				}, 
				{
					"targets": "enhanced-table-column-width-25%",
					"width": "25%",
				}, 
			],
			language: {
				"processing": "Procesează...",
				"lengthMenu": "Afișează _MENU_ înregistrări pe pagină",
				"zeroRecords": "Nu am găsit nimic - ne pare rău",
				"info": "Afișate de la _START_ la _END_ din _TOTAL_ înregistrări",
				"infoEmpty": "Afișate de la 0 la 0 din 0 înregistrări",
				"infoFiltered": "(filtrate dintr-un total de _MAX_ înregistrări)",
				"search": "Caută:",
				"aria": {
					"sortAscending": "Sortează ascendent",
					"sortDescending": "Sortează descendent"
				},
				"autoFill": {
					"cancel": "Anulează",
					"fill": "Completează",
					"fillVertical": "Completează celule vertical",
					"fillHorizontal": "Completeză celule orizonal"
				},
				"buttons": {
					"csv": "CSV",
					"excel": "Excel",
					"pageLength": {
						"-1": "Arată toate rândurile",
						"_": "Arată %d rânduri"
					},
					"pdf": "PDF",
					"print": "Imprimă",
					"collection": "Colecție",
					"colvis": "Vizibilitate coloane",
					"copy": "Copie",
					"copyTitle": "Copie în Clipboard",
					"colvisRestore": "Resetare vizibilitate",
					"copyKeys": "Apasă ctrl sau u2318 + C pentru a copia datele din tabel în clipboard-ul sistemului.<br \/><br \/>Pentru a anula, dați clic pe acest mesaj sau apăsați pe Escape.",
					"createState": "Creează Stare",
					"removeAllStates": "Înlătură Toate Stările",
					"removeState": "Înlătură",
					"renameState": "Redenumește",
					"savedStates": "Salvează Stări"
				},
				"searchBuilder": {
					"add": "Adaugă",
					"value": "Valoare",
					"condition": "Condiție",
					"data": "Data",
					"logicAnd": "Și",
					"logicOr": "Sau",
					"button": {
						"0": "Generator de căutare",
						"_": "Generator de căutare (%d)"
					},
					"clearAll": "Curata tot",
					"conditions": {
						"date": {
							"after": "După",
							"before": "Inainte de",
							"between": "Între",
							"empty": "Gol"
						}
					},
					"deleteTitle": "Ștergeți regula de filtrare",
					"leftTitle": "Criterii Outdent",
					"rightTitle": "Criterii de indentare",
					"title": {
						"0": "Generator de căutare",
						"_": "Generator de căutare (%d)"
					}
				},
				"loadingRecords": "Încarcă...",
				"datetime": {
					"previous": "Precedentă",
					"next": "Următoare",
					"hours": "Ore",
					"minutes": "Minute",
					"seconds": "Secunde",
					"unknown": "Necunoscut",
					"amPm": [
						"AM",
						"PM"
					],
					"weekdays": [
						"lun",
						"Mar",
						"Mer",
						"Joi",
						"Vin",
						"Sam",
						"Dum"
					],
					"months": [
						"Ianuarie",
						"Februarie",
						"Martie",
						"Aprilie",
						"Mai",
						"Iunie",
						"Iulie",
						"August",
						"Septembrie",
						"Octombrie",
						"Noiembrie",
						"Decembrie"
					]
				},
				"editor": {
					"create": {
						"button": "Nou",
						"title": "Crează o intrare nouă",
						"submit": "Crează"
					},
					"edit": {
						"button": "Editează",
						"submit": "Editează",
						"title": "Editează rând"
					},
					"remove": {
						"button": "Șterge",
						"title": "Șterge",
						"submit": "Șterge",
						"confirm": {
							"_": "Sigur doriți să ștergeți %d rânduri?",
							"1": "Sigur doriți să ștergeți 1 rând?"
						}
					},
					"close": "Închide",
					"error": {
						"system": "A apărut o eroare."
					},
					"multi": {
						"title": "Valori multiple",
						"info": "Elementele selectate conțin valori diferite pentru această intrare. Pentru a edita și a seta toate elementele pentru această intrare la aceeași valoare, faceți clic sau atingeți aici, altfel își vor păstra valorile individuale.",
						"restore": "Anulează modificările",
						"noMulti": "Această intrare poate fi editată individual, dar nu face parte dintr-un grup."
					}
				},
				"decimal": ",",
				"emptyTable": "Nu există date în tabel",
				"searchPlaceholder": "Caută în tabel",
				"thousands": ".",
				"infoThousands": ".",
				"paginate": {
					"first": "Prima pagină",
					"last": "Ultima pagină",
					"next": "→",
					"previous": "←"
				}
			},
		});
		

	})(jQuery);	

	// Sliders
	// https://swiperjs.com/get-started

	const recentContentSlider = new Swiper('.recent-content-slider', {
		slidesPerView: 1,
		spaceBetween: 10,
		autoplay: {
			delay: 5000,
		  },
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});